// extracted by mini-css-extract-plugin
export var actionButton = "_jh-t";
export var buttonContainer = "_jh-0";
export var buttonContainer2 = "_jh-1";
export var buttonSection = "_jh-2";
export var details = "_jh-3";
export var dropdownItem = "_jh-5";
export var dropdownItemsContainer = "_jh-4";
export var fileInput = "_jh-r";
export var headerButton = "_jh-6";
export var icon = "_jh-7";
export var input = "_jh-8";
export var macroListItem = "_jh-9";
export var mainContent = "_jh-a";
export var microText = "_jh-b";
export var modal = "_jh-w";
export var optionsButton = "_jh-c";
export var paperclip = "_jh-s";
export var pillContent = "_jh-d";
export var preview = "_jh-e";
export var preview2 = "_jh-f";
export var quillEditor = "_jh-q";
export var selectedMacro = "_jh-g";
export var sidebar = "_jh-h";
export var sidebarHeader = "_jh-j";
export var sidebarList = "_jh-i";
export var sidebarListItem = "_jh-k";
export var sidebarSearch = "_jh-l";
export var snoozeDurationWrapper = "_jh-v";
export var statusPillContainer = "_jh-m";
export var tagsContainer = "_jh-n";
export var unselectedMacro = "_jh-o";
export var variable = "_jh-u";
export var wrapper = "_jh-p";